/** True when `value` is a valid 9-digit Norwegian organization number (mod-11 checksum). */
export const isValidNorwegianOrganizationNumber = (value: string): boolean => {
  const digits = value.replace(/\s/g, '');

  if (!/^\d{9}$/.test(digits)) {
    return false;
  }

  const weights = [3, 2, 7, 6, 5, 4, 3, 2];
  const checksum = weights.reduce((sum, weight, i) => sum + parseInt(digits[i]!) * weight, 0);
  const remainder = checksum % 11;
  const expectedCheckDigit = remainder === 0 ? 0 : 11 - remainder;

  if (expectedCheckDigit === 10) {
    return false;
  }

  return parseInt(digits[8]!) === expectedCheckDigit;
};
